export var providerLimitValues = function (merchantResponseData, provider) {
    var data = merchantResponseData.data;
    return data.limits.find(function (limit) { return limit.provider === provider; });
};
